import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidationSummary } from '@sd-portal/shared/validation';
import { AppSaveService } from '../../app-save/app-save.service';

@Component({
  selector: 'sd-portal-error-summary-item',
  templateUrl: './error-summary-item.component.html',
  styleUrls: ['./error-summary-item.component.scss']
})
export class ErrorSummaryItemComponent implements OnInit {
  @Input() validationSummary: ValidationSummary;
  @Input() parentKey: string;
  @Output() controlSelected = new EventEmitter();

  get displayKey() {
    const { validationSummary, parentKey } = this;
    if (validationSummary) {
      let { key } = validationSummary;
      if (!isNaN(Number(key))) {
        const nkey = Number(key) + 1;
        key = String(nkey);
        if (parentKey) {
          key = `${parentKey} - ${nkey}`;
        }
      }

      return key;
    }

    return '';
  }

  constructor(private readonly appSaveService: AppSaveService) {}

  ngOnInit() {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  focusControl(control: any) {
    if ('nativeElement' in control) {
      setTimeout(() => {
        control.nativeElement.focus();
      }, 500);
    } else if ('id' in control) {
      const { id } = control;
      this.appSaveService.selectNgrxControlId(id);
    }

    this.controlSelected.emit();
  }
}
